import {gql, useMutation} from "@apollo/client";

const DELETE_SEASON_MUTATION = gql`
mutation DeleteSeason($seasonId: Int!) {
  deleteSeason(seasonId: $seasonId) {
    success    
  }
}

`;

export default function DeleteSeasonMutation() {
    return useMutation(DELETE_SEASON_MUTATION);
}